var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isOpen
    ? _c("ModalFullScreen", {
        on: { close: _vm.handleClose },
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function () {
                return [
                  _c("h2", { staticClass: "text-md font-bold" }, [
                    _vm._v(_vm._s(_vm.projectTitle)),
                  ]),
                  _c("h3", { staticClass: "text-lg pt-0.5 font-medium" }, [
                    _vm._v(
                      " Start a new group message, this will open up in your inbox "
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c("FormGroup", {
                    staticClass: "mt-3.5",
                    attrs: {
                      inputClass: "customFullWidthInput",
                      name: "conversation_name",
                      isIcon: false,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c("p", { staticClass: "mb-2" }, [
                                _vm._v(" Chat name "),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2319458357
                    ),
                    model: {
                      value: _vm.conversationName,
                      callback: function ($$v) {
                        _vm.conversationName = $$v
                      },
                      expression: "conversationName",
                    },
                  }),
                  _vm.groupConversationUsers.length
                    ? _c(
                        "div",
                        { staticClass: "py-4" },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-md text-primary-black font-bold mb-4",
                            },
                            [_vm._v("Group members")]
                          ),
                          _vm._l(_vm.checkboxOptions, function (option) {
                            return _c("Checkbox", {
                              key: option.userId,
                              attrs: { id: option.userId, name: option.name },
                              model: {
                                value: option.selected,
                                callback: function ($$v) {
                                  _vm.$set(option, "selected", $$v)
                                },
                                expression: "option.selected",
                              },
                            })
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "py-1 flex justify-end" },
                    [
                      _c("UiButton", {
                        staticClass: "mr-3",
                        attrs: {
                          variant: "outline",
                          buttonText: "Cancel",
                          buttonClasses: "customButtonCard",
                        },
                        on: { click: _vm.handleClose },
                      }),
                      _c("UiButton", {
                        attrs: {
                          buttonText: "Create",
                          buttonClasses: "customButtonCard",
                          variant: "black",
                          type: "submit",
                          disabled: !_vm.selectedUsers.length,
                        },
                        on: { click: _vm.createGroupConversation },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2507834803
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }